import { constants } from '../../constants/ConfigurationConstants';

const { inputTypes, units } = constants;

export default {
    itemInfo: {
        itemIdTemplate: 'id',
        itemLabelKey: 'description',
    },
    pageTitle: 'KPI Targets',
    siteMapKey: 'swc.settings.kpiconfiguration',
    onlineHelpId: 1084,
    sectionsLabel: 'Targets',
    selectOptionKeys: [],
    sectionListCollapsible: false,
    sections: [
        {
            id: 'systemTargets',
            label: 'System Targets',
            subSections: [
                {
                    label: 'Loading',
                    parameters: [
                        {
                            label: 'Load Rate Target',
                            parameterKey: 'SmartBag.BagsLoadedPercent',
                            inputType: inputTypes.number,
                            displayUnit: units.percentage,
                            unit: units.percentage,
                            min: 0,
                            max: 100,
                            kpiType: 'system',
                            kpiConfigurationKey: 'SmartBag.BagsLoadedPercent',
                        },
                        {
                            label: 'Bags Not Loaded Percent Threshold',
                            parameterKey: 'SmartBag.BagsNotLoadedPercent',
                            inputType: inputTypes.number,
                            displayUnit: units.percentage,
                            unit: units.percentage,
                            min: 0,
                            max: 100,
                            kpiType: 'system',
                            kpiConfigurationKey: 'SmartBag.BagsNotLoadedPercent',
                        },
                        {
                            label: 'Bag Drop Dispatch Rate Target',
                            parameterKey: 'Enterprise.TargetTagDispatchTime',
                            inputType: inputTypes.number,
                            displayUnit: units.minutes,
                            unit: units.minutes,
                            min: 0,
                            max: 1440,
                            kpiType: 'system',
                            kpiConfigurationKey: 'Enterprise.TargetTagDispatchTime',
                        },
                        {
                            label: 'To Unload Time Past Arrival Yellow Threshold',
                            parameterKey:
                                'Enterprise.UnloadTimePastArrivalYellowThresholdMinutes',
                            inputType: inputTypes.number,
                            displayUnit: units.minutes,
                            unit: units.minutes,
                            min: 0,
                            max: 1440,
                            kpiType: 'system',
                            kpiConfigurationKey:
                                'Enterprise.UnloadTimePastArrivalYellowThresholdMinutes',
                        },
                        {
                            label: 'To Unload Percent Yellow Threshold',
                            parameterKey:
                                'Enterprise.UnloadArrivalYellowThresholdPercentage',
                            inputType: inputTypes.number,
                            displayUnit: units.percentage,
                            unit: units.percentage,
                            min: 0,
                            max: 100,
                            kpiType: 'system',
                            kpiConfigurationKey:
                                'Enterprise.UnloadArrivalYellowThresholdPercentage',
                        },
                        {
                            label: 'To Unload Time Past Arrival Red Threshold',
                            parameterKey:
                                'Enterprise.UnloadTimePastArrivalRedThresholdMinutes',
                            inputType: inputTypes.number,
                            displayUnit: units.minutes,
                            unit: units.minutes,
                            min: 0,
                            max: 1440,
                            kpiType: 'system',
                            kpiConfigurationKey:
                                'Enterprise.UnloadTimePastArrivalRedThresholdMinutes',
                        },
                        {
                            label: 'To Unload Percent Red Threshold',
                            parameterKey: 'Enterprise.UnloadArrivalRedThresholdPercentage',
                            inputType: inputTypes.number,
                            displayUnit: units.percentage,
                            unit: units.percentage,
                            min: 0,
                            max: 100,
                            kpiType: 'system',
                            kpiConfigurationKey:
                                'Enterprise.UnloadArrivalRedThresholdPercentage',
                        },
                        {
                            label: 'To Load Time Before Departure Yellow Threshold',
                            parameterKey:
                                'Enterprise.LoadTimeBeforeDepartureYellowThresholdMinutes',
                            inputType: inputTypes.number,
                            displayUnit: units.minutes,
                            unit: units.minutes,
                            min: 0,
                            max: 1440,
                            kpiType: 'system',
                            kpiConfigurationKey:
                                'Enterprise.LoadTimeBeforeDepartureYellowThresholdMinutes',
                        },
                        {
                            label: 'To Load Percent Yellow Threshold',
                            parameterKey:
                                'Enterprise.LoadDepartureYellowThresholdPercentage',
                            inputType: inputTypes.number,
                            displayUnit: units.percentage,
                            unit: units.percentage,
                            min: 0,
                            max: 100,
                            kpiType: 'system',
                            kpiConfigurationKey:
                                'Enterprise.LoadDepartureYellowThresholdPercentage',
                        },
                        {
                            label: 'To Load Time Before Departure Red Threshold',
                            parameterKey:
                                'Enterprise.LoadTimeBeforeDepartureRedThresholdMinutes',
                            inputType: inputTypes.number,
                            displayUnit: units.minutes,
                            unit: units.minutes,
                            min: 0,
                            max: 1440,
                            kpiType: 'system',
                            kpiConfigurationKey:
                                'Enterprise.LoadTimeBeforeDepartureRedThresholdMinutes',
                        },
                        {
                            label: 'To Load Percent Red Threshold',
                            parameterKey: 'Enterprise.LoadDepartureRedThresholdPercentage',
                            inputType: inputTypes.number,
                            displayUnit: units.percentage,
                            unit: units.percentage,
                            min: 0,
                            max: 100,
                            kpiType: 'system',
                            kpiConfigurationKey:
                                'Enterprise.LoadDepartureRedThresholdPercentage',
                        },
                    ],
                },
            ],
        },
    ],
};
